import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import {
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  MenuItem,
  Tooltip,
  Card,
} from "@mui/material";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledButton,
  OutlinedIconFab,
  theme,
  StyledMultilineTextField,
} from "../StyledComponents";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";
import Icon from "../Utils/Icons";
import { ProceduresTable } from "../Sections/ProceduresTable";

const ProceduresSimplified = ({
  sectionName,
  activeSection,
  suggestions,
  aiSuggestionToggle,
  ruleSuggestionToggle,
  handleCrossButtonClick,
  data,
  setData,
  startRecording,
  stopRecording,
  isAiEnabled,
}) => {
  console.log("Inside Procedures", data);

  const [listeningOn, setListeningOn] = useState(false);
  const [newProcedure, setNewProcedure] = useState({
    term: "",
    id: null,
  });
  const [procedureName, setProcedureName] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);
  const [procedures, setProcedures] = useState(data);
  const [validationErrors, setValidationErrors] = useState({
    term: "",
  });

  useEffect(() => {
    setProcedures(data);
  }, [data]);

  const validateFields = () => {
    const errors = {};

    if (!newProcedure.term && procedureName.length === 0) {
      errors.term = "Procedures Name is a mandatory field.";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0; // Return true if no errors
  };
  // Function to handle adding a new row
  const handleAdd = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    // Add the new term to the complaints list
    let updatedDetails = [...procedures, newProcedure];
    console.log("Procedure Updated Details", updatedDetails);
    setProcedures(updatedDetails);
    setNewProcedure({
      term: "",
      id: null,
      clinical_note: "",
    });
    setValidationErrors({}); // Clear errors after successful submission
    setProcedureName("");
    setData(updatedDetails);
  };

  // Function to handle input changes
  const handleInputChange = (field, value) => {
    let newDetails;
    if (field == "term") {
      newDetails = {
        ...newProcedure,
        [field]: value.term,
        id: value.id,
      };
    } else {
      newDetails = {
        ...newProcedure,
        [field]: value,
      };
    }

    setNewProcedure(newDetails);
  };

  // Function to handle row edit
  const handleEditRow = (index) => {
    setProcedureName(procedures[index].term);
    setNewProcedure({ ...procedures[index] });
    setEditingIndex(index);
    // handleDeleteRow(index); // Remove the row from the list temporarily
  };
  console.log("Editing Index", editingIndex);
  const handleUpdate = async () => {
    if (!validateFields()) {
      return; // Exit if validation fails
    }

    let newDetails;

    newDetails = { ...newProcedure, source: undefined };
    let updatedDetails = procedures.map((data, i) =>
      i == editingIndex ? newDetails : data
    );
    setProcedures(updatedDetails);
    setEditingIndex(null);
    setNewProcedure({
      ...newProcedure,
      term: "",
      id: null,
      clinical_note: "",
    });
    setProcedureName("");
    setData(updatedDetails);
  };
  // Function to handle row delete
  const handleDeleteRow = (index) => {
    let updatedDetails = procedures.filter((_, i) => i !== index);
    setProcedures(updatedDetails);
    setData(updatedDetails);
  };

  const handleClearName = () => {
    setValidationErrors({});
    setProcedureName("");
    setNewProcedure({
      ...newProcedure,
      id: null,
      term: "", // Use computed property name to set the field dynamically
    });
  };

  const handleConditionTyped = (value) => {
    setProcedureName(value);
    handleInputChange("term", { term: value, id: null });
  };

  console.log("Procedures data", procedures);
  return (
    <ThemeProvider theme={theme}>
      {activeSection && (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <Grid
              container
              spacing={2}
              sx={{
                marginTop: "5px",
                padding: "10px",
              }}
            >
              <Grid item xs={10} sm={8} md={6}>
                <StyledTextField
                  value={procedureName}
                  onChange={(e) => {
                    handleConditionTyped(e.target.value);
                  }}
                  InputProps={{
                    endAdornment: (
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div style={{ marginRight: "5px" }}>
                          <Tooltip title="Clear">
                            <OutlinedIconFab
                              size="small"
                              variant="contained"
                              onClick={handleClearName}
                            >
                              <Icon name="clearTextField" size={32} />
                            </OutlinedIconFab>
                          </Tooltip>
                        </div>

                        {/* <>
                          {isAiEnabled &&
                            (listeningOn === false ? (
                              <Tooltip title="Start Listening">
                                <OutlinedIconFab
                                  onClick={() => {
                                    startRecording();
                                    setListeningOn(true);
                                  }}
                                  variant="contained"
                                  color="defaultColor"
                                  size="small"
                                >
                                  <Icon name="micNotInUse" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Stop Listening">
                                <OutlinedIconFab
                                  onClick={() => {
                                    stopRecording("Procedures");
                                    setListeningOn(false);
                                  }}
                                  variant="outlined"
                                  color="defaultColor"
                                  size="small"
                                >
                                  <Icon name="micInUse" size={32} />
                                </OutlinedIconFab>
                              </Tooltip>
                            ))}
                        </> */}
                      </div>
                    ),
                  }}
                  label="Procedure Name"
                  fullWidth
                  error={!!validationErrors.term} // Highlight field in red if there's an error
                  helperText={validationErrors.term} // Show error message
                />
              </Grid>
              <Grid item xs={10} sm={8} md={6}>
                <StyledMultilineTextField
                  value={newProcedure.clinical_note}
                  onChange={(e) =>
                    handleInputChange("clinical_note", e.target.value)
                  }
                  placeholder="Clinical Notes"
                  fullWidth
                />
              </Grid>
              <Grid item xs={2} sx={{ display: "flex", alignItems: "center" }}>
                <StyledButton
                  bgColor="#0E3F66"
                  onClick={editingIndex != null ? handleUpdate : handleAdd}
                  variant="contained"
                  sx={{
                    fontSize: { xs: "0.8rem", sm: "1rem" },
                    width: "100%",
                  }}
                >
                  {editingIndex != null ? "Update" : "Add"}
                </StyledButton>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      )}
      {procedures && (
        <ProceduresTable
          data={procedures}
          activeSection={activeSection}
          handleEditRow={handleEditRow}
          handleDeleteRow={handleDeleteRow}
        />
      )}
    </ThemeProvider>
  );
};

export default ProceduresSimplified;
